<template>
  <div
    id="element"
    class="forgot-password"
  >
    <div class="forgot-password--item">
      <Header/>
    </div>
    <vue-recaptcha
      ref="recaptcha"
      :sitekey="siteKey"
      size="invisible"
      @verify="sendEmail"
      @expired="onCaptchaExpired"
    />
    <div class="section-gray">
      <div class="section-white">
        <div
          v-if="!isSubmit"
          class="forgot-password--title"
        >
          <div style="margin-bottom: 32px;">
            <span class="status-name">{{ $t('forgot_password.forgot_password') }}</span>
          </div>
        </div>
        <div v-if="isSubmit">
          <div class="forgot-password--title">
            {{ $t('forgot_password.sent') }}
          </div>
          <div class="forgot-password--detail">
            {{ $t('forgot_password.please_check_your_email_and_confirm') }}
            {{ $t('forgot_password.if_you_do_not_receive') }}
          </div>
          <div class="forgot-password--detail">
            {{ $t('forgot_password.email_will_from') }} <b>info@kulap.io</b>
          </div>
        </div>
        <div v-else>
          <div class="forgot-password--detail">
            {{ $t('forgot_password.enter_your_email') }}
          </div>
          <b-field
            :label="`${$t('forgot_password.email')}:`"
            class="email-field"
          >
            <b-input
              v-validate="'required|email'"
              v-model="email"
              :disabled="isLoading"
              :placeholder="$t('forgot_password.email_placeholder')"
              name="email"
              type="text"
            />
          </b-field>
          <div class="is-invalid">{{ errors.first('email') }}</div>
          <b-button
            :loading="isLoading"
            class="send-email-btn"
            @click="executeRecaptcha"
          >
            {{ $t('buttons.submit') }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="forgot-password--item">
      <Footer/>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import Service from './service'
import { kulapApi } from '@/resources'
import Header from '@/features/Header'
import Footer from '@/components/Footer'
import { showToastError } from '@/utils/helper'
import { RECAPTCHA_SITE_KEY } from '@/constants'

export default {
  name: 'ForgotPassword',
  components: {
    Header,
    Footer,
    VueRecaptcha
  },
  data () {
    return {
      service: null,
      email: '',
      isSubmit: false,
      isLoading: false,
      siteKey: RECAPTCHA_SITE_KEY
    }
  },
  async created () {
    this.service = new Service({
      store: this.$store,
      kulapApi
    })
  },
  methods: {
    executeRecaptcha () {
      this.isLoading = true
      this.$refs.recaptcha.execute()
      this.$scrollTo('.forgot-password--item')
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
      this.isLoading = false
    },
    async sendEmail (recaptchaToken) {
      try {
        await this.service.sendForgotPasswordEmail(this.email, recaptchaToken)
        this.$buefy.toast.open({
          message: 'An email has been sent, please check your email.',
          type: 'is-success'
        })
        this.isSubmit = true
      } catch (e) {
        showToastError(e)
      }
      this.$refs.recaptcha.reset()
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.forgot-password {
  float: left;
  width: 100%;
  min-height: 100vh;

  &--item {
    float: left;
    width: 100%;
  }

  &--title {
    margin: 0 0 25px 0;
    font-size: 21px;
    font-weight: bold;
    text-align: center;
    color: #000000;
  }

  &--detail {
    color: grey;
    text-align: center;
  }
}
.section-gray {
  float: left;
  width: 100%;
  padding-bottom: 170px;
  text-align: center;
}
.section-white {
  display: inline-block;
  padding: 32px 47px;
  width: fit-content;
  max-width: 450px;
  border-radius: 5px;
  box-shadow: 0 2px 4px -3px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  text-align: left;
}
.email-field {
  margin-top: 40px;
}
.status-name {
  font-size: 27px;
  font-weight: bold;
  vertical-align:middle
}
.send-email-btn {
  float: left;
  width: 100%;
  text-align: center;
  color: #fff;
  background-color: #0458af;
  padding: 20px 10px;
  font-weight: bold;
  border-radius: 3px;
  border: unset;
  cursor: pointer;
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  .section-gray {
    padding-bottom: 1rem;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .section-white {
    width: 95vw;
    max-width: calc(100vw - 20px);
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ForgotPassword/index.vue